import RelationshipMetadata from "../../RelationshipMetadata";

class AdminWorkGroupAdminWorkGroupPositionRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminWorkGroupAdminWorkGroupPositionRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminWorkGroup";
        this.childEnterpriseComponent = "AdminWorkGroupPosition";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default AdminWorkGroupAdminWorkGroupPositionRelationshipMetadata;